export default __webpack_public_path__ + "static/media/livenyte-colored_cmprs.5d597ded.png";